import React, { useEffect, useRef, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import moment from "moment";
import "./erxHtmlRenderSettingView.scss";
import FormInputWithHeader from "../../../common/FormInputWithHeader";
import { ERX_LANGUAGE_LIST } from "../../ERXConstants/constants";
import reset from "../../../../assets/reset.svg";
import dragAndDropIcon from "../../../../assets/dragHandle.svg";
import printIcon from "../../../../assets/print-black.svg";
import downloadFileIcon from "../../../../assets/download-black.svg";
import shareIcon from "../../../../assets/share-black.svg";
import printBlueIcon from "../../../../assets/print-blue.svg";
import downloadFileBlueIcon from "../../../../assets/download-blue.svg";
import shareBlueIcon from "../../../../assets/share-blue.svg";
import PDFViewForC2C from "../../ERXPdfViewContainer/PDFViewForC2C";
import ComponentSpecificLoader from "../../../UI Component/Loader/ComponentSpecificLoader";
import axios from "axios";
import ShareWithPharmacyBtn from "../../common/ShareWithPharmacyBtn";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";

const ErxHtmlRenderSettingView = (props) => {
  const {
    languageButtonLoader,
    htmlTemplate,
    pharmacyList,
    defaultPharmacy,
    alignmentOptions,
    setHtmlTemplate,
    setAlignmentOptions,
    setAlertMessage,
    setLanguageButtonLoader,
    handleSaveLanguageAPICall,
    handleResetSettings,
    handleApproveAndShareRX,
    getGeneratedPrescriptionPdf,
    erxPdfData,
    lang,
    pdfMainContent,
    pdfPath,
    handleSharePharmacyBtn,
  } = props;

  const dragItem = useRef();
  const dragOverItem = useRef();

  const [languageList, setLanguageList] = useState(ERX_LANGUAGE_LIST);
  const [draggable, setDraggable] = useState(true);
  const [ERXButtons, setERXButtons] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState("");
  const [pdfBlob, setPdfBlob] = useState("");
  const [loader, setLoader] = useState(false);
  const presDate = moment().format("DD MMM YYYY");

  const [downloadIconHover, setDownloadIconHover] = useState(false);
  const [printIconHover, setPrintIconHover] = useState(false);
  const [shareIconHover, setShareIconHover] = useState(false);

  const showShareBtn = localStorage.getItem(
    LOCALSTORAGEKEY.ENABLE_ALLOW_SHARE_RX
  );

  // LifeCycle Methods ===>

  useEffect(() => {
    languageList.forEach((language) => {
      language.selected = language.languageCode === htmlTemplate?.languageCode;
    });
    setLanguageList([...languageList]);
  }, [htmlTemplate]);

  // <===

  // Helper Methods ===>

  const handleSettingsApiCall = (langCode, isDefault) => {
    let options = {};
    alignmentOptions.forEach((ele) => {
      options[ele.name] = { sort: ele.sort, alignment: ele.alignment };
    });
    setLanguageButtonLoader(true);
    let data = {
      langCode: langCode,
      is_default_locale: isDefault,
      alignment_options: options,
    };
    handleSaveLanguageAPICall(data);
  };

  // <===

  // Actions ===>

  const handleDownloadMouseOver = () => {
    setDownloadIconHover(true);
  };

  const handleDownloadMouseOut = () => {
    setDownloadIconHover(false);
  };

  const handlePrintMouseOver = () => {
    setPrintIconHover(true);
  };

  const handlePrintMouseOut = () => {
    setPrintIconHover(false);
  };

  const handleShareMouseOver = () => {
    setShareIconHover(true);
  };

  const handleShareMouseOut = () => {
    setShareIconHover(false);
  };

  const printPDF = () => {
    if (window?.innerWidth < 768) {
      window.open(pdfBlobUrl, "PRINT", "height=400,width=600");
    } else {
      const iframe = document.createElement("iframe"); //load content in an iframe to print later
      document.body.appendChild(iframe);

      iframe.style.display = "none";
      iframe.src = pdfBlobUrl;
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow.print();
        }, 1);
      };
    }
  };

  const handleDefaultAlertMessage = () => {
    setTimeout(() => {
      setAlertMessage({
        show: false,
        title: "",
        content: "",
        type: "",
      });
    }, 2000);
  };

  const handleGeneratePrescriptionOptions = async () => {
    setERXButtons(true);
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer);
    let bufferbase64 = new Buffer.from(buffer, "base64");

    const file = dataURLtoFile(
      "data:pdf;base64," + bufferbase64?.toString("base64")
    );

    const data = new FormData();
    Object.keys(pdfPath.fields).forEach((keyName) => {
      data.append(keyName, pdfPath.fields[keyName]);
    });
    data.append("file", file, "prescription_pdf");

    axios
      .post(pdfPath.url, data, {
        headers: {
          "Content-Type":
            "multipart/form-data;boundary=--WebKitFormBoundaryE19zNvXGzXaLvS5C",
        },
      })
      .then((response) => {
        console.log(response);
        getGeneratedPrescriptionPdf();
        if (defaultPharmacy) {
          setAlertMessage({
            show: true,
            title: "",
            content: {
              __html: `Patient’s prescription has been shared successfully with the pharmacy`,
            },
            type: "success",
          });
          handleDefaultAlertMessage();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n) {
      u8arr[n - 1] = bstr.charCodeAt(n - 1);
      n -= 1; // to make eslint happy
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleSelectLanguage = (val) => {
    let ind = languageList.findIndex((language) => language.id === val.id);
    languageList.forEach((language) => {
      language.selected = false;
    });
    languageList[ind].selected = true;
    setLanguageList([...languageList]);
    setHtmlTemplate({
      languageCode: languageList[ind].languageCode,
      isTemplateDefault: false,
      languageCodeAferApiCall: "",
    });
    handleSettingsApiCall(languageList[ind].languageCode, false);
    setERXButtons(false);
  };

  const handleDefaultTemplate = () => {
    setHtmlTemplate({ ...htmlTemplate, isTemplateDefault: true });
    handleSettingsApiCall(htmlTemplate?.languageCode, true);
  };

  const handleLeftRightAlignment = (item, val) => {
    let ind = alignmentOptions.findIndex(
      (erxComponent) => erxComponent.name === item.name
    );
    alignmentOptions[ind].alignment = val;
    setHtmlTemplate({ ...htmlTemplate, isTemplateDefault: false });
    setAlignmentOptions([...alignmentOptions]);
  };

  const toggleDrag = (val) => {
    setDraggable(val);
    setERXButtons(false);
  };

  const onDragStart = (pos) => {
    dragItem.current = pos;
    setERXButtons(false);
  };

  const onDragEnter = (pos) => {
    dragOverItem.current = pos;
    setERXButtons(false);
  };

  const drop = () => {
    let dragItemContent = alignmentOptions[dragItem.current - 1];
    alignmentOptions.splice(dragItem.current - 1, 1);
    alignmentOptions.splice(dragOverItem.current - 1, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;

    alignmentOptions.forEach((ob, index) => {
      ob.sort = index + 1;
    });
    setHtmlTemplate({ ...htmlTemplate, isTemplateDefault: false });
    setAlignmentOptions([...alignmentOptions]);
  };

  const handleReset = () => {
    setERXButtons(false);
    handleResetSettings();
  };
  // <===

  // Display UI ===>

  const displayShareWithPharmacyBtnUI = () => {
    return (
      <>
        <ShareWithPharmacyBtn
          handleSharePharmacyBtn={() =>
            handleSharePharmacyBtn(erxPdfData?.prescription_id, "erx")
          }
        />
      </>
    );
  };

  const displayErxSettings = () => {
    return (
      <div className="erx-settings-ui-container">
        <div className="erx-settings-ui-header">Customize eRx Print</div>
        <div className="erx-settings-ui-content" onDragEnd={drop}>
          {alignmentOptions.map((item, ind) => (
            <div
              key={ind}
              ref={dragItem}
              draggable={draggable}
              onDragEnter={() => {
                onDragEnter(item.sort);
              }}
              onDragStart={() => {
                onDragStart(item.sort);
              }}
            >
              {!item.hideSectionInPreview && (
                <div className="erx-settings-ui" ref={dragOverItem}>
                  <div
                    className="erx-settings-ui-title"
                    onMouseDown={() => toggleDrag(false)}
                    onMouseUp={() => toggleDrag(true)}
                  >
                    {item.title}
                  </div>
                  <div className="erx-settings-ui-right-content">
                    {item.showLeftRightAlignment && (
                      <div
                        className="erx-settings-ui-left-right-container"
                        onMouseDown={() => toggleDrag(false)}
                        onMouseUp={() => toggleDrag(true)}
                      >
                        <div
                          className={
                            "erx-settings-ui-left-right-text " +
                            (item.alignment === "left"
                              ? "erx-settings-ui-selected"
                              : "")
                          }
                          onClick={() => handleLeftRightAlignment(item, "left")}
                        >
                          Left
                        </div>
                        <div
                          className={
                            "erx-settings-ui-left-right-text " +
                            (item.alignment === "right"
                              ? "erx-settings-ui-selected"
                              : "")
                          }
                          onClick={() =>
                            handleLeftRightAlignment(item, "right")
                          }
                        >
                          Right
                        </div>
                      </div>
                    )}
                    <div style={{ cursor: "pointer" }}>
                      <img
                        alt=""
                        src={dragAndDropIcon}
                        className="erx-settings-ui-drag-icon"
                        onMouseDown={() => toggleDrag(true)}
                        onMouseUp={() => toggleDrag(false)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const displayDefaultTemplateOption = () => {
    return (
      <div className="erx-settings-btn-container">
        <div className="erx-setting-checkbox">
          <div className="checkbox-wrapper">
            <label className="m-0">
              <input
                type="checkbox"
                checked={htmlTemplate?.isTemplateDefault}
                onChange={handleDefaultTemplate}
                className={htmlTemplate?.isTemplateDefault ? "checked" : ""}
                disabled={htmlTemplate?.isTemplateDefault}
              />
              <span>Make Default Template</span>
            </label>
          </div>
        </div>
      </div>
    );
  };

  const displaySettingFooter = () => {
    return (
      <div className="erx-settings-footer">
        {loader && <ComponentSpecificLoader />}
        <div
          className={
            ERXButtons ? "erx-buttons-wrapper" : "erx-buttons-wrapper-hide"
          }
        >
          <PDFDownloadLink
            document={
              <PDFViewForC2C
                erxPdfData={erxPdfData}
                lang={lang}
                alignmentOptions={alignmentOptions}
                pdfMainContent={pdfMainContent}
              />
            }
            fileName={`${erxPdfData?.patient_name}_${presDate}.pdf`}
          >
            {({ loading, url, blob }) =>
              loading ? (
                <>
                  {setLoader(true)}
                  <div className="erx-button-disabled">
                    <img src={downloadFileIcon} alt="#" />
                    Loading...
                  </div>
                </>
              ) : (
                <>
                  {setPdfBlobUrl(url)}
                  {setPdfBlob(blob)}
                  {setLoader(false)}
                  <span
                    className="erx-button"
                    data-tooltip="Download"
                    data-tooltip-conf="top"
                  >
                    <img
                      src={
                        downloadIconHover
                          ? downloadFileBlueIcon
                          : downloadFileIcon
                      }
                      alt="#"
                      className="erx-button-icon"
                      onMouseOver={handleDownloadMouseOver}
                      onMouseOut={handleDownloadMouseOut}
                    />
                  </span>
                </>
              )
            }
          </PDFDownloadLink>
          <span
            className="erx-button"
            data-tooltip="Print"
            data-tooltip-conf="top"
            onClick={() => printPDF()}
          >
            <img
              src={printIconHover ? printBlueIcon : printIcon}
              alt="#"
              className="erx-button-icon"
              onMouseOver={handlePrintMouseOver}
              onMouseOut={handlePrintMouseOut}
            />
          </span>
          <span
            className="erx-button"
            data-tooltip="Approve & Share"
            data-tooltip-conf="top"
            onClick={() => handleApproveAndShareRX()}
          >
            <img
              src={shareIconHover ? shareBlueIcon : shareIcon}
              alt="#"
              className="erx-button-icon"
              onMouseOver={handleShareMouseOver}
              onMouseOut={handleShareMouseOut}
            />
          </span>

          {pharmacyList.length > 0 && displayShareWithPharmacyBtnUI()}
        </div>
        <div
          className={
            ERXButtons
              ? "erx-buttons-wrapper-hide"
              : `erx-settings-btn ${
                  languageButtonLoader ? "erx-settings-disable-btn" : ""
                }`
          }
          // onClick={handleGeneratePrescription}
          onClick={handleGeneratePrescriptionOptions}
        >
          Generate Prescription
        </div>
      </div>
    );
  };

  // <===

  return (
    <div className="erx-settings-container">
      <div className="erx-settings-cont">
        <div className="erx-settings-header">
          <div className="erx-settings-heading">eRx Settings</div>
          <div className="erx-settings-reset" onClick={handleReset}>
            <img src={reset} alt="" className="erx-settings-reset-icon" /> Reset
          </div>
        </div>
        <div
          className={
            "erx-settings-select-content " +
            (languageButtonLoader ? "erx-not-clickable" : "")
          }
        >
          <div className="erx-settings-select">
            <FormInputWithHeader
              title="Language"
              inputType="dropdown"
              value={
                languageList.find(
                  (language) =>
                    language.languageCode === htmlTemplate?.languageCode
                )?.label
              }
              options={languageList}
              handleOnChangeInput={handleSelectLanguage}
            />
          </div>
          {displayErxSettings()}
          {displayDefaultTemplateOption()}
        </div>
      </div>
      {displaySettingFooter()}
    </div>
  );
};

export default ErxHtmlRenderSettingView;
